import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

const Pause: IconNode = [
  'svg',
  defaultAttributes,
  [
    ['rect', { width: '4', height: '16', x: '6', y: '4' }],
    ['rect', { width: '4', height: '16', x: '14', y: '4' }],
  ],
];

export default Pause;
